import React, { FC } from 'react';

import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';

import TemplateKeys from '../../../utils/contentModuleTemplateKeys';

import './styles.scss';

const Footer: FC = () => (
    <footer>
        <ContentModule
            baseUrl={window.recordsSettings.franchiseScopedRestUrl}
            templateKey={TemplateKeys.FOOTER}
            sequence={3}
            isPublic
        />

        <div className="footer-modules">
            <ContentModule
                baseUrl={window.recordsSettings.franchiseScopedRestUrl}
                templateKey={TemplateKeys.FOOTER}
                sequence={1}
                isPublic
            />
        </div>
        <div className="copyright">
            <img src="https://secure.nhl.com/logos/nhl/svgz/NHL_dark.svgz" />
            <div>
                <ContentModule
                    baseUrl={window.recordsSettings.franchiseScopedRestUrl}
                    templateKey={TemplateKeys.FOOTER}
                    sequence={2}
                    isPublic
                />
            </div>
        </div>
    </footer>
);

export default Footer;
